import { useState, useEffect } from "react";
import RecentActivityHead from "./RecentActivityHead";
import RecentActivityList from "./RecentActivityList";
import { db } from "../../../firebase";
import { useAuth } from "../../../contexts/AuthContext";

const RecentActivity = () => {
  const {
    userInfo,
    currentUser,
    setTotalExpenses,
    setTotalMargin,
    setTotalRevenue,
  } = useAuth();
  const [info, setInfo] = useState([]);

  const monthsDays = (month, year) => new Date(year, month, 0).getDate();

  const marginMoney = (amount, todayExpense) => {
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();
    const days = monthsDays(currentYear, currentMonth);
    const dailySalary = (amount / days).toFixed(2);
    const margin = dailySalary - todayExpense;
    return margin.toFixed(2);
  };

  useEffect(() => {
    if (userInfo?.isSalary) {
      let sumExpenses = 0;

      const unsubscribe = db.salaries
        .where("userId", "==", currentUser.uid)
        .orderBy("date", "desc")
        .onSnapshot((querySnapshot) => {
          let salaryData = [];
          querySnapshot.forEach((doc) => {
            salaryData.push({
              id: doc.id,
              data: doc.data(),
            });
            sumExpenses += doc.data().todayExpense;
          });
          setInfo(salaryData);
          setTotalExpenses(sumExpenses);
          setTotalMargin(userInfo?.salaryDetails?.monthlySalary - sumExpenses);
          sumExpenses = 0;
        });

      return () => unsubscribe();
    } else {
      let sumExpenses = 0;
      let sumRevenue = 0;

      const unsubscribe = db.nonsalaries
        .where("userId", "==", currentUser.uid)
        .orderBy("date", "desc")
        .onSnapshot((querySnapshot) => {
          let nonSalaryData = [];
          querySnapshot.forEach((doc) => {
            nonSalaryData.push({
              id: doc.id,
              data: doc.data(),
            });
            sumExpenses += doc.data().todayExpense;
            sumRevenue += doc.data().todayRevenue;
          });
          setInfo(nonSalaryData);
          setTotalExpenses(sumExpenses);
          setTotalRevenue(sumRevenue);
          setTotalMargin(sumRevenue - sumExpenses);
          sumExpenses = 0;
          sumRevenue = 0;
        });

      return () => unsubscribe();
    }
  }, [
    userInfo,
    currentUser,
    setTotalExpenses,
    setTotalMargin,
    setTotalRevenue,
  ]);

  return (
    <>
      {info && console.log(info)}
      <div className="p-8 flex flex-col space-y-2">
        <h1 className="text-md font-semibold text-gray-700">Recent Activity</h1>
        <div className="flex flex-col">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <RecentActivityHead userInfo={userInfo} />

                  <tbody className="bg-white divide-y divide-gray-200">
                    {info &&
                      info.map((item, i) =>
                        userInfo?.isSalary ? (
                          <RecentActivityList
                            userInfo={userInfo}
                            key={item.id}
                            id={item.id}
                            date={item?.data?.date.toDate()}
                            todayExpense={item?.data?.todayExpense}
                            description={item?.data?.description}
                            margin={marginMoney(
                              userInfo?.salaryDetails?.monthlySalary,
                              item?.data?.todayExpense
                            )}
                          />
                        ) : (
                          <RecentActivityList
                            userInfo={userInfo}
                            key={item.id}
                            id={item.id}
                            date={item?.data?.date.toDate()}
                            todayExpense={item?.data?.todayExpense}
                            todayRevenue={item?.data?.todayRevenue}
                            description={item?.data?.description}
                            margin={
                              item?.data?.todayRevenue -
                              item?.data?.todayExpense
                            }
                          />
                        )
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecentActivity;
